import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { IconComponent } from "../design-system/components/icon/icon.component";
import { CheckInSummaryModel } from "../check-ins-summary/check-ins-statuses";
import {
  SURVEY_ANNUAL,
  SURVEY_DAY_ONE, SURVEY_MONTH_FOUR,
  SURVEY_MONTH_ONE, SURVEY_MONTH_SIX,
  SURVEY_MONTH_THREE,
  SURVEY_MONTH_TWO,
  SURVEY_WEEK_ONE
} from "../utils/check-ins-summary.util";
import { SurveysToDisplay } from "../check-ins-summary/check-ins-summary.component";
import { NgClass } from "@angular/common";

@Component({
  selector: 'lib-check-ins-summary-survey-list',
  standalone: true,
  imports: [
    IconComponent,
    NgClass
  ],
  templateUrl: './check-ins-summary-survey-list.component.html',
  styleUrl: './check-ins-summary-survey-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckInsSummarySurveyListComponent {

  readonly checkInsSummary = input<CheckInSummaryModel[] | null>(null);
  readonly outsideSelectedSurvey = input<string>('');
  readonly onCheckInSelected = output<string>();

  readonly surveysToDisplay = signal<any[]>([
    { name: SURVEY_DAY_ONE, label: '1d' },
    { name: SURVEY_WEEK_ONE, label: '1w' },
    { name: SURVEY_MONTH_ONE, label: '1m' },
    { name: SURVEY_MONTH_TWO, label: '2m' },
    { name: SURVEY_MONTH_THREE, label: '3m' },
    { name: SURVEY_MONTH_FOUR, label: '4m' },
    { name: SURVEY_MONTH_SIX, label: '6m' },
    { name: SURVEY_ANNUAL, label: '1y' }
  ]);

  readonly checkInsSummaryFormatted = computed((): SurveysToDisplay[] => {
    const checkIns = this.checkInsSummary();

    if (!checkIns) return [];

    return this.surveysToDisplay().map(s => ({
      ...s,
      statusIcon: checkIns.find(c => c.surveyTitle == s.name)?.statusIcon
        || 'checkInsStatusDefaultIcon'
    }));
  });

  isItemClickable(statusIcon: string): boolean {
    return statusIcon !== 'checkInsStatusDefaultIcon' && statusIcon !== 'checkInsStatusMissedIcon';
  }

  checkInClicked(surveyName: string, statusIcon: string): void {
    if (this.isItemClickable(statusIcon)) {
      this.onCheckInSelected.emit(surveyName);
    }
  }

}
